import React, { PureComponent, ReactNode } from 'react'
import HomePageAuthorized from './HomePageAuthorized'
import HomePagePublic from './HomePagePublic'
import { AuthContext } from '../AuthContext'

interface IState {
  authenticated: boolean
}
class HomePage extends PureComponent<{}, IState> {
  // static contextType = AuthContext
  render(): ReactNode {
    return (
      <AuthContext.Consumer>
        {(context) => (
          context.authenticated ? <HomePageAuthorized /> : <HomePagePublic />
        )}
      </AuthContext.Consumer>
    )
  }
}

export default HomePage
